export const REVENUE_HEADER_TOOLTIP = [
    'Рассчитывается по расчетному месяцу.',
    'Период накопления: со 2 числа месяца по 1 число следующего.',
    'Средняя выручка берется за расчетный месяц.'
].join('\n');

const MULTIPLE_PERIODS_LABEL = 'несколько расчетных месяцев';

export const getRevenuePeriodSummary = (reports) => {
    const relevantReports = (reports || []).filter(report => report?.averageCumulativeRevenuePeriodLabel);
    if (!relevantReports.length) {
        return null;
    }

    const firstReport = relevantReports[0];
    const hasSinglePeriod = relevantReports.every(report =>
        report.averageCumulativeRevenueMonth === firstReport.averageCumulativeRevenueMonth &&
        report.averageCumulativeRevenuePeriodStart === firstReport.averageCumulativeRevenuePeriodStart &&
        report.averageCumulativeRevenuePeriodEnd === firstReport.averageCumulativeRevenuePeriodEnd &&
        report.averageCumulativeRevenuePeriodLabel === firstReport.averageCumulativeRevenuePeriodLabel
    );

    if (hasSinglePeriod) {
        return {
            averageCumulativeRevenueMonth: firstReport.averageCumulativeRevenueMonth,
            averageCumulativeRevenuePeriodStart: firstReport.averageCumulativeRevenuePeriodStart,
            averageCumulativeRevenuePeriodEnd: firstReport.averageCumulativeRevenuePeriodEnd,
            averageCumulativeRevenuePeriodLabel: firstReport.averageCumulativeRevenuePeriodLabel
        };
    }

    return {
        averageCumulativeRevenuePeriodLabel: MULTIPLE_PERIODS_LABEL
    };
};

export const buildAverageCumulativeRevenueTooltip = (item, formattedRevenue) => {
    const lines = [`Прогнозная выручка: ${formattedRevenue}`];

    if (!item?.averageCumulativeRevenuePeriodLabel) {
        lines.push('Расчетный месяц: нет данных');
        return lines.join('\n');
    }

    if (item.averageCumulativeRevenuePeriodLabel === MULTIPLE_PERIODS_LABEL) {
        lines.push('Расчетный месяц: несколько расчетных месяцев');
        return lines.join('\n');
    }

    lines.push(`Расчетный месяц: ${item.averageCumulativeRevenuePeriodLabel}`);
    return lines.join('\n');
};
